import { defaultGuid } from '@equifinance/shared';
import { Credit } from './Credit';

export const defaultCredit: Credit = {
  updateCount: 0,
  dirtyCount: 0,
  initiator: '',
  id: defaultGuid,
  securedCreditItems: {
    id: defaultGuid,
    creditItems: {},
  },
  unsecuredCreditItems: {
    id: defaultGuid,
    creditItems: {},
  },
  applicants: [],
  addresses: {},
  insolvencyRecords: {
    id: defaultGuid,
    insolvencyRecords: {},
  },
  disbursementSummary: {
    id: defaultGuid,
    disbursementGroups: [],
    disbursements: [],
    total: 0,
  },
  errors: {},
  warnings: {},
  productsResultDigest: null,
};
